export const enum TakerValidationRoute {
  PERSONAL_INFO,
  EDUCATION,
  WORK_EXPERIENCE,
  URLS,
  INTERVIEWS,
  MEETING
}
